import * as yup from 'yup';

export const coveragePeriodSchema = yup.object({
  effectiveFrom: yup.date().required().nullable(),
  effectiveUntil: yup.date().required().nullable(),
});

export type CoveragePeriodFormFields = yup.InferType<
  typeof coveragePeriodSchema
>;
